import { useEffect } from 'react';
import { useIoContext } from '~/providers/IoContext';
const normalizeEmail = (email)=>email.trim().toLowerCase();
export const guardBiometricUserSwitch = async (claims, vault)=>{
    if (claims == null || claims.impersonate != null) {
        return;
    }
    const enrolledEmail = await vault.getEnrolledEmail();
    const enrolledForDifferentUser = enrolledEmail != null && normalizeEmail(enrolledEmail) !== normalizeEmail(claims.email);
    if (enrolledForDifferentUser) {
        await vault.disable();
    }
};
export const useBiometricUserSwitchGuard = ()=>{
    const { cookies, native } = useIoContext();
    useEffect(()=>{
        if (!native.isNative) {
            return;
        }
        void guardBiometricUserSwitch(cookies.getClaims(), native.biometric);
    }, [
        native.isNative
    ]);
};
